import _ from "lodash";

import {getFromStorage, USER_KEY} from "./utils/storage";
import {UserUtils} from "./utils/utils";
import {SharedSettingsResource} from "./utils/api";

const BROKER = {
  RISK_DASHBOARD: {
    path: '/risk-dashboard',
    name: 'Risikoanalyse'
  },
  REPORTING: {
    children: {
      CUSTOMERS: {
        children: {
          COVER: {
            newDesignPath: '/customer/:customer_id/cover'
          },
          PREVIEW: {
            newDesignPath: '/customer/:customer_id/preview'
          }
        },
        newDesignPath: '/customers'
      },
      SINGLE_CUSTOMER: {
        newDesignPath: '/single-reporting',
        children: {
          REPORT:{
            newDesignPath: '/:customer_id/report'
          },
          AUTO_REPORT:{
            newDesignPath: '/:customer_id/auto_report'
          }
        }
      },
      GROUP: {
        newDesignPath: '/group-reporting',
        children: {
          REPORT:{
            newDesignPath: '/:group_id/report'
          },
          AUTO_REPORT:{
            newDesignPath: '/:group_id/auto_report'
          }
        }
      }
    }
  },
  GROUP: {
    path: '/group-settings'
  },
  SERIES_REPORTING: {
    newDesignPath: '/series-reporting',
    children: {
      SINGLE_CUSTOMER: {
        newDesignPath: '/single-reporting',
        children: {
          REPORT:{
            newDesignPath: '/single-reporting/:customer_id/report'
          },
          AUTO_REPORT:{
            newDesignPath: '/single-reporting/:customer_id/auto_report'
          }
        }
      },
      GROUP: {
        newDesignPath: '/group-reporting',
        children: {
          REPORT:{
            newDesignPath: '/group-reporting/:group_id/report'
          },
          AUTO_REPORT:{
            newDesignPath: '/group-reporting/:group_id/auto_report'
          }
        }
      }
    }
  },

  GROUP_CREATE: {
    newDesignPath: '/create'
  },
  DASHBOARD_GROUP_CREATE: {
    path: '/dashboard-group-settings/create',
    newDesignPath: '/create'
  },
  GROUP_UPDATE: {
    newDesignPath: '/group/:group_id'
  },
  NEW_GROUP_UPDATE: {
    path: '/new-group-settings/:group_id',
    newDesignPath: '/group/:group_id'
  },
  DASHBOARD_GROUP_UPDATE: {
    path: '/dashboard-group-settings-update/:group_id',
    newDesignPath: '/group/:group_id'
  },
  FORM_CENTER: {
    path: '/form-center/:customer_id/',
    name: 'Form Center'
  }
};

const CUSTOMER = {
  LOGIN: {
    path: '/:agency_id/login'
  },
  DOCUMENTS: {
    path: '/:agency_id/documents',
    name: 'Postfach'
  },
  DASHBOARD: {
    path: '/:agency_id/portfolio-dashboard',
    name: 'Vermögensübersicht'
  },
  DASHBOARD_VIRTUAL: {
    path: '/:agency_id/virtual-portfolio/:customer_id/dashboard',
    name: 'Virtuelle Depots'
  },
  VIRTUAL_PORTFOLIO_MANAGER: {
    path: '/:agency_id/virtual-portfolio/management/:portfolio_id',
    name: 'Virtuelle Depots'
  },
  OTHER_ASSETS: {
    path: '/:agency_id/other-assets',
    name: 'Sonstige Vermögenswerte'
  },
  OTHER_ASSETS_LIST: {
    path: '/:agency_id/other-assets/list',
    name: 'Sonstige Vermögenswerte'
  },
  OTHER_ASSETS_CATEGORY: {
    path: '/:agency_id/other-assets/category/:category_id',
    name: 'Sonstige Vermögenswerte'
  },
  OTHER_ASSETS_IFC: {
    path: '/:agency_id/other-assets-new',
    name: 'Sonstige Vermögenswerte'
  },
  FACTSHEETS_DASHBOARD: {
    path: '/factsheets/:isin',
    name: 'Factsheets'
  }
};

export const ROUTES = {
  BROKER,
  CUSTOMER
};

const getCurrentCustomerAgencyId = () => {
  const user = JSON.parse(getFromStorage(USER_KEY) || '{}');
  return user.agency && user.agency.agency_id;
};

const updateCustomerPath = (path, agency_id) => {
  return path.replace(':agency_id', agency_id || getCurrentCustomerAgencyId());
};

export const buildCurrentCustomerLoginPath = (agency_id) => {
  return updateCustomerPath(ROUTES.CUSTOMER.LOGIN.path, agency_id);
};

export const buildCurrentCustomerDocumentsPath = () => {
  return updateCustomerPath(ROUTES.CUSTOMER.DOCUMENTS.path);
};

export const buildCurrentCustomerDashboardPath = () => {
  return updateCustomerPath(ROUTES.CUSTOMER.DASHBOARD.path);
};

export const buildCurrentCustomerDashboardVirtualPath = (customer_id) => {
  let path =  updateCustomerPath(ROUTES.CUSTOMER.DASHBOARD_VIRTUAL.path);
  path = path.replace(':customer_id', customer_id);
  return path;
};

export const buildCurrentCustomerVirtualPortfolioManager = (portfolio_id) => {
  let path = ROUTES.CUSTOMER.VIRTUAL_PORTFOLIO_MANAGER.path;
  path = path.replace(':agency_id', getCurrentCustomerAgencyId());
  path = path.replace(':portfolio_id', portfolio_id);
  return path;
};

export const buildCurrentCustomerOtherAssetsPath = () => {
  return updateCustomerPath(ROUTES.CUSTOMER.OTHER_ASSETS.path);
};

export const buildCurrentCustomerOtherAssetsListPath = () => {
  return updateCustomerPath(ROUTES.CUSTOMER.OTHER_ASSETS_LIST.path);
};

export const buildCurrentCustomerOtherAssetsCategoryPath = (category_id) => {
  return updateCustomerPath(ROUTES.CUSTOMER.OTHER_ASSETS_CATEGORY.path)
    .replace(':category_id', category_id);
};

export const buildFactSheetsLink = (isin) => {
  return ROUTES.CUSTOMER.FACTSHEETS_DASHBOARD.path
    .replace(':isin', isin);
};

const allowedItem = (item, auth) => {
  return item.beta ? UserUtils.isBetaUser(auth) : true;
}

const filterMenuItems = (arr, auth) => {
  return arr.filter(item => {
    const isAllowed = allowedItem(item, auth);

    if (isAllowed && item.children) {
      item.children = filterMenuItems(item.children, auth)
    }

    return isAllowed;
  });
}

export const getMenuItems = async(auth, components) =>{
  // if components is passed - only items from this list are retrieved
  let response = await SharedSettingsResource.at('menu-configuration/').post({components});
    if (_.isArray(response)) {
      response = filterMenuItems(response, auth);
    }

  return response
}